import React from 'react';
import store from '../store';
import { RESET_CITY,FILE_IMAGES } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import _ from 'lodash'
const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%',
    maxWidth: 680
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  }
});
var _this;
function matchYoutubeUrl(url) {
    var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    if(url.match(p)){
        return url.match(p)[1];
    }
    return false;
}
class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),
      open: false,
      image:null

    }
    _this = this;
  }
  componentDidMount(props)
  {
    var item = this.state.item;
    if(item.image)
    {
      var image_preview = item.image;
      this.setState({image_preview});
    }
  }





  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;
    if(name=="order")
    {
      item[name] = parseInt(event.target.value?event.target.value:0);
    }
    else
    item[name] = event.target.value;

    _this.setState({ item });
  }



async  CreateItem  (data) {

    const item = data;

    //var check = window.confirm("Do you want to add category?");
    var _this=this;

          var docRef = firebase.firestore().collection("categories").doc();

            docRef.set(item)
              .then(function () {
                item.id = docRef.id;
                item.order = item.order?parseInt(item.order):0;
                console.log(item);
                  //store.dispatch({ type: 'CREATE_DISTRICT', item });
                NotificationManager.success("Success!");
              //  _this.setState(RESET_CITY);
                _this.props.onClose();
              })
              .catch(function (error) {
                console.error(error);
              });






  }

  async SaveItem  (data)  {
    //event.preventDefault();
    const item = data;

    var _this=this;

      const id = item.id;

      firebase.firestore().collection("categories").doc(id).update(item)
        .then(function () {
          item.id = id;
          //item.order = item.order?parseInt(item.order):0;
          //let index = store.getState().CITIES.findIndex(e => e.id === id);
          //store.dispatch({ type: 'UPDATE_DISTRICT', item, index });
          NotificationManager.success("Success!");
        //  _this.setState(RESET_CITY);
          _this.props.onClose();
        })
        .catch(function (error) {
          console.error(error);
        });



  }
  DeleteItem = (id) => event => {
    var check = window.confirm("Do you want to delete this category?");
    var _this=this;
    if (check === true) {
        firebase.firestore().collection("categories").doc(id).delete().then(()=>{
            NotificationManager.success("Success!");
            _this.props.onClose();
        });
    }

  }
  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };


  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item } = this.state;

    const isEnabled = !item ? false : item.name && item.order;
    return (<div>
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}>{this.state.item.id ? <EditIcon /> : <LocationOnIcon />}</Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}>{item.id ? 'Edit' : 'New'} Category</Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="body2" color="primary" style={{ marginBottom: 10 }}></Typography>
            <Divider style={{ marginBottom: 5 }} />
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.name}
                  onChange={this.handleChange('name')}
                  label="Category Name"
                  fullWidth
                  required
                  placeholder=""
                  type="text"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>


            </Grid>
            <Grid container>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.type}
                  onChange={this.handleChange('type')}
                  label="Type"
                  fullWidth
                  required
                  select

                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                >
                <MenuItem value={0}>
              Meals
            </MenuItem>
            <MenuItem value={1}>
              Drinks
            </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs style={{ margin: 5 }}>
                <TextField
                  value={item.order}
                  onChange={this.handleChange('order')}
                  label="Display Order"
                  fullWidth
                  required
                  placeholder=""
                  type="number"
                  margin="normal"
                  className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>

            </Grid>





          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>}
            {!item.id ? <Button onClick={()=>this.CreateItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
              <SaveIcon style={{ marginRight: 5 }} />Create
          </Button> :
              <Button onClick={()=>this.SaveItem(item)} disabled={!isEnabled} size="large" variant="contained" color="secondary">
                <SaveIcon style={{ marginRight: 5 }} />SAVE
        </Button>}
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
